import { useSelector } from '@xstate/react';
import cn from 'classnames';
import { useCallback, useMemo } from 'react';

import { useTextStyle } from '@webapp/common/components/custom-styles';
import { CssQuestionType } from '@webapp/common/components/survey-custom';
import { Textfield, TextfieldType } from '@webapp/common/components/textfield';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import css from './number.css';

const style = { width: '30vw', minWidth: '240px' };

const imaskOptions = {
    thousandsSeparator: ' ',
    scale: 4,
};

export const Number: VFC<SurveyQuestion> = ({
    question: {
        params: { maxLength, minLength },
        responseActor,
        id,
    },
}) => {
    const { value } = useSelector(responseActor, (s) => s.context);
    const min = typeof minLength === 'number' ? minLength : -1 * globalThis.Number.MAX_SAFE_INTEGER;
    const max = typeof maxLength === 'number' ? maxLength : globalThis.Number.MAX_SAFE_INTEGER;

    const { inputStyle } = useTextStyle();

    const finalStyle = useMemo(
        () => ({
            ...inputStyle,
            style,
        }),
        [inputStyle],
    );
    const change = useCallback(
        (value) => {
            responseActor.send({ type: 'CHANGE', value, questionId: id });
        },
        [responseActor],
    );
    return (
        <div className={cn(CssQuestionType.QUESTION, CssQuestionType.NUMBER, css.number)}>
            <Textfield
                transparent
                className={css.control}
                defaultValue={value as string | number}
                imaskOptions={imaskOptions}
                max={max}
                min={min}
                style={finalStyle}
                type={TextfieldType.IMASK_IRRATIONAL}
                onChange={change}
            />
        </div>
    );
};
Number.displayName = 'Number';
